import { useCallback, useContext } from 'react';
import { useWatch } from 'react-hook-form';

import { useLanguage } from 'assets/languages';
import TextInputField from 'components/textInput';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import CampaignFormField from 'pages/campaigns/campaignForm/components/campaignFormContainer/components/campaignFormSteps/components/campaignFormFieldGroup/components/campaignFormField/campaignFormField';

const MAX_LENGTH = 200;

const ReelsRequestsField = () => {
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };

  const { brand, guidelineRuleFormMethods } = useContext(CampaignFormContext);

  const reelsRequestsValue = useWatch({
    control: guidelineRuleFormMethods.control,
    name: 'REELS_REQUESTS.value',
  }) as string;

  const onChangeReelsRequestsValue = useCallback(
    (value: string) => {
      let newValue = value;

      if (value.length > MAX_LENGTH) {
        newValue = value.slice(0, MAX_LENGTH);
      }

      guidelineRuleFormMethods.setValue('REELS_REQUESTS.value', newValue);
    },
    [guidelineRuleFormMethods],
  );

  return (
    <CampaignFormField
      label={
        <>
          {brand.isWholesale ? 1 : 2}.{' '}
          {languageTexts.create_reels_form_video_guideline}
          <span>
            {languageTexts._create_max_length_indicator(
              reelsRequestsValue?.length || 0,
              MAX_LENGTH,
            )}
          </span>
        </>
      }
    >
      <TextInputField
        bordered
        placeholder={languageTexts.create_reels_form_guideline}
        value={reelsRequestsValue || ''}
        onChangeText={onChangeReelsRequestsValue}
      />
    </CampaignFormField>
  );
};

export default ReelsRequestsField;
